import React from 'react'
import { Col, Row } from 'antd'

const DownloadsTabsContent = ({ setDataSourceCopy, keyTab, fetchData, onEdit, selectedOption, searchText, component: TabContentComponent, lowStock }) => (
  <Row gutter={16} className={'section-space-field'}>
    {selectedOption ? (
      <Col span={24} className={'margin-top-15'}>
        {<TabContentComponent setDataSourceCopy={setDataSourceCopy} keyTab={keyTab} fetchData={fetchData} onEdit={onEdit} selectedOption={selectedOption} searchText={searchText} lowStock={lowStock}/>}
      </Col>
    ) : (
      <Col span={24} className={'empty-section-container'}>
        <div className={'empty-section'}>
          <span className={'empty-section-message'}>Por favor selecciona una tienda</span>
        </div>
      </Col>
    )}
  </Row>
)

export default DownloadsTabsContent
